'use client';
import { AgeGroups, Form, FormSubmitButton } from '@baseball-near-you/ui';
import { useTeamAgeGroupMutation } from '@bb/lib/mutations/useTeamAgeGroupsMutation';
import { z } from 'zod';
import { AgeGroupCheckbox } from './AgeGroupCheckbox';

export function TeamAgeGroupsForm(props: {
  teamId: number;
  onSuccess: () => void;
}) {
  const { addAgeGroup } = useTeamAgeGroupMutation({ teamId: props.teamId });

  return (
    <div className="flex flex-col space-y-5">
      <p>Select the age groups in your program.</p>
      <Form
        onSubmit={async (data) => {
          const ageGroups = data.ageGroups;
          await addAgeGroup(
            ageGroups.map((ageGroup: any) => ({
              age: ageGroup,
              name: (ageGroup as any) === '18+' ? '18+' : `${ageGroup}U`,
              description: '',
            }))
          );
          props.onSuccess();
        }}
        schema={z.object({
          ageGroups: z.array(z.string()).refine(
            (data) => {
              return data.every((ageGroup) => AgeGroups.includes(ageGroup));
            },
            {
              message: 'Invalid age group',
            }
          ),
        })}
        initialValues={{
          ageGroups: [],
        }}
        className="flex flex-col space-y-5"
      >
        <div className="mt-4 grid grid-cols-2 gap-4">
          {Object.values(AgeGroups).map((ageGroup) => (
            <AgeGroupCheckbox key={ageGroup} ageGroup={ageGroup} />
          ))}
        </div>
        <FormSubmitButton label="Add age groups to team" />
      </Form>
    </div>
  );
}
